import {Grid, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {Answer, type AnswerProps} from './Answer'
import {classes} from './Question.classes'
import {useQuestionArrangement} from './Question.hooks'

type Props = Omit<AnswerProps, 'answer'>

export function Question({handleAnswerClick, question}: Props): React.ReactElement<Props> {
  const {alignItems, direction} = useQuestionArrangement(question)

  return (
    <Grid
      alignItems={alignItems}
      className={classes.root}
      container
      direction={direction}
      justify="space-between"
      wrap="nowrap"
    >
      <Grid className={classes.text} item>
        <Typography group="tight" thickness="regular" variant="caption1">
          {question.text}
        </Typography>
      </Grid>
      <Grid
        className={clsx(classes.answers, direction === 'column' && classes.column)}
        container
        item
        size="xs"
        wrap="nowrap"
      >
        {question.answers.map(answer => (
          <Grid item key={answer.id}>
            <Answer answer={answer} handleAnswerClick={handleAnswerClick} question={question} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
